/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { SalespersonBudgetListItemDto } from './salesperson-budget.dto';
import { SalespersonBudgetListItemMapper } from './salesperson-budget.mapper';

@Injectable()
export class SalespersonBudgetRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(): Observable<SalespersonBudgetListItemDto[]> {
    return this.httpGet(`${this.bp}/budgets`, arrayOf(SalespersonBudgetListItemMapper));
  }

  update(items: SalespersonBudgetListItemDto[]): Observable<SalespersonBudgetListItemDto[]> {
    return this.httpPut(`${this.bp}/budgets`, items, arrayOf(SalespersonBudgetListItemMapper));
  }
}
